import React from "react";
import { FaArrowRight, FaBolt, FaChartLine } from "react-icons/fa";
import { Link } from "react-router-dom";

const stats = [
  { label: "Active Members", value: "100+" },
  { label: "Practice Contests", value: "100+" },
  { label: "Problems Solved", value: "100K+" },
  { label: "Mentors", value: "10+" },
];

const HeroSection = () => {
  return (
    <section className="home-section pt-32 sm:pt-36">
      <div className="home-container relative">
        <div className="glow-orb -left-8 top-8 h-24 w-24 bg-black/20" />
        <div className="glow-orb -right-8 bottom-8 h-24 w-24 bg-white/30" />

        <div className="home-card-strong relative overflow-hidden p-7 sm:p-10 md:p-12">
          <div className="absolute -right-16 -top-16 h-52 w-52 rounded-full border" style={{ borderColor: "var(--border)" }} />
          <div className="absolute -left-16 -bottom-16 h-52 w-52 rounded-full border" style={{ borderColor: "var(--border)" }} />

          <span className="section-kicker">GUB Competitive Programming Community</span>
          <h1 className="home-title mt-4 max-w-5xl text-3xl font-bold sm:text-5xl lg:text-6xl">
            Train with structure.{" "}
            <span className="home-accent-gradient">Compete with confidence.</span>{" "}
            Grow with community.
          </h1>
          <p className="mt-5 max-w-3xl text-base sm:text-lg home-muted">
            GUB Competitive Programming Community is a focused learning hub where beginners and advanced coders build algorithms, contest habits, and team discipline.
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/join-committee" className="home-btn-primary inline-flex items-center gap-2 px-5 py-3 text-sm font-semibold">
              Join Community <FaArrowRight className="text-xs" />
            </Link>
            <Link to="/resume-maker" className="home-btn-secondary inline-flex items-center gap-2 px-5 py-3 text-sm font-semibold">
              CV Maker <FaArrowRight className="text-xs" />
            </Link>
            <Link to="/committee" className="home-btn-secondary inline-flex items-center gap-2 px-5 py-3 text-sm font-semibold">
              Meet Committee <FaBolt className="text-xs" />
            </Link>
            <Link to="/events" className="home-btn-secondary inline-flex items-center gap-2 px-5 py-3 text-sm font-semibold">
              Explore Events <FaChartLine className="text-xs" />
            </Link>
          </div>

          <div className="mt-10 grid grid-cols-2 gap-3 md:grid-cols-4">
            {stats.map((item) => (
              <div key={item.label} className="home-card p-4">
                <div className="text-2xl font-bold home-accent">{item.value}</div>
                <div className="mt-1 text-xs uppercase tracking-wide home-muted">{item.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
